/**
 * String Constants
 * Centralized string constants for UI text and fallback patterns
 */

export const FALLBACK_TEXT = {
  VEHICLE: (id) => `Vehicle ${id?.slice(0, 8) || 'Unknown'}...`,
  CUSTOMER: (id) => `Customer ${id?.slice(0, 8) || 'Unknown'}...`,
  SITE: (id) => `Site ${id?.slice(0, 8) || 'Unknown'}...`,
}

export const UI_STRINGS = {
  VEHICLES: 'Vehicles',
  NO_VEHICLES_FOUND: 'No vehicles found for this site.',
  RETRY: 'Retry',
  NO_ACCESS_ERROR:
    "Your account doesn't have access to any customers or sites yet. Contact your administrator to get access.",
  // Add more as found
}
